'use strict';
Object.defineProperty(exports, Symbol.toStringTag, {
    value: 'Module'
});
function maxBy(items, getValue) {
    if (items.length === 0) {
        return undefined;
    }
    var maxElement = items[0];
    var max = getValue(maxElement);
    for(var i = 1; i < items.length; i++){
        var element = items[i];
        var value = getValue(element);
        if (value > max) {
            max = value;
            maxElement = element;
        }
    }
    return maxElement;
}
exports.maxBy = maxBy;
